import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import "./CookieBanner.css";

// ---- Consent Mode v2 helpers ----
const ensureGtag = () => {
  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function () {
      window.dataLayer.push(arguments);
    };
};

const initConsentDefaults = () => {
  ensureGtag();

  // Default consent BEFORE user choice
  window.gtag("consent", "default", {
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    analytics_storage: "denied",
    functionality_storage: "granted",
    security_storage: "granted",
    wait_for_update: 500,
  });
};

const grantConsent = () => {
  ensureGtag();
  window.gtag("consent", "update", {
    ad_storage: "granted",
    ad_user_data: "granted",
    ad_personalization: "granted",
    analytics_storage: "granted",
  });
};

const denyConsent = () => {
  ensureGtag();
  window.gtag("consent", "update", {
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    analytics_storage: "denied",
  });
};

// ---- Component ----
const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Always set a default consent state on page load
    initConsentDefaults();

    const consent = Cookies.get("userConsent");

    // If no choice yet, show banner
    if (!consent) {
      setIsVisible(true);
      return;
    }

    // Apply saved choice
    if (consent === "accepted") {
      grantConsent();
    } else {
      denyConsent();
    }
  }, []);

  const acceptCookies = () => {
    Cookies.set("userConsent", "accepted", {
      expires: 365,
      sameSite: "None",
      secure: true,
    });

    setIsVisible(false);
    grantConsent();
  };

  const rejectCookies = () => {
    Cookies.set("userConsent", "rejected", {
      expires: 365,
      sameSite: "None",
      secure: true,
    });

    setIsVisible(false);
    denyConsent();
  };

  return (
    isVisible && (
      <div
        className="cookie-banner centered"
        role="dialog"
        aria-labelledby="cookie-banner-title"
        aria-describedby="cookie-banner-description"
      >
        <div className="cookie-banner-text">
          <h2 id="cookie-banner-title" className="sr-only">
            Cookie Preferences
          </h2>

          <p id="cookie-banner-description" style={{ margin: 0 }}>
            Vi använder cookies för att analysera och förbättra din upplevelse.
            Genom att klicka på "Acceptera" samtycker du till vår användning av
            cookies enligt vår{" "}
            <a
              href="/privacy-policy"
              className="cookie-link"
              aria-label="Läs vår integritetspolicy"
            >
              Integritetspolicy
            </a>
            .
          </p>
        </div>

        <div className="cookie-banner-buttons">
          <button
            onClick={rejectCookies}
            className="cookie-button"
            aria-label="Avböj cookies"
          >
            Avböj
          </button>

          <button
            onClick={acceptCookies}
            className="cookie-button"
            aria-label="Acceptera cookies"
          >
            Acceptera
          </button>
        </div>
      </div>
    )
  );
};

export default CookieBanner;
